export class AppRoutingConstants {
    static ROUTE_SEPERATOR = "/";
    static PATH_MATCH_FULL = "full";
    static API_PREFIX = "api";
    static API_UNSECURED_PREFIX = "apiunsecured";
    static API_VERSION_2 = "v2";
    static MODULE_ID_ROUTE_PARAMETER = ":moduleID";
    static ORGANISATION_ROUTE_ID_PARAMETER = ":organisationID";
    static MOBILE_CONFIG_ROUTE = "mobileconfig";
    static ORGANISATION_CONFIG_ROUTE = "organisations";
    static ORGANISATION_APPLY_ACCESS_ROUTE = "applyaccess";
    static MAINTENANCE_MODE_CONFIG_ROUTE = "maintenancemodeconfig";
    static LOGIN_ROUTE = "login";
    static LOGIN_ROUTE_WITH_RETURN_URL = "login?returnUrl=";
    static LOGOUT_ROUTE = "logout";
    static START_LOGIN = "startLogin";
    static TOKEN_PARAMETER = "#id_token";
    static AFLA_LOGOUT_PATH = "/afla/logout";
    static MAINTENANCE_PATH = "maintenance";
    static createEndpointRoutev2(...endpointSuffixRoutes) {
        const endpointURL = AppRoutingConstants.API_PREFIX + AppRoutingConstants.ROUTE_SEPERATOR + AppRoutingConstants.API_VERSION_2 + AppRoutingConstants.ROUTE_SEPERATOR + endpointSuffixRoutes.join(AppRoutingConstants.ROUTE_SEPERATOR);
        const emptySpaceRe = new RegExp(" ", "gi");
        return endpointURL.replace(emptySpaceRe, "");
    }
    static createRouteToView(...routeComponents) {
        const route = routeComponents.join(AppRoutingConstants.ROUTE_SEPERATOR);
        const emptySpaceRe = new RegExp(" ", "gi");
        const DashRe = new RegExp("-", "gi");
        const DoubleRouteRe = new RegExp(this.ROUTE_SEPERATOR + this.ROUTE_SEPERATOR, "gi");
        return route.replace(emptySpaceRe, "").toLowerCase().replace(DashRe, "").replace(DoubleRouteRe, this.ROUTE_SEPERATOR);
    }
    static createRouteToViewWithPrefixRouteSeparator(...routeComponents) {
        const routeComponentsWithSeparator = [AppRoutingConstants.ROUTE_SEPERATOR, ...routeComponents];
        return AppRoutingConstants.createRouteToView(...routeComponentsWithSeparator);
    }
}
